"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineComponent = void 0;
var React = require("react");
exports.LineComponent = function (props) {
    var classString = props.value.style === 'thick' ? 'thick-style' : 'thin-style';
    return (React.createElement("div", { className: 'component line-component', "data-component-type": 'line' },
        React.createElement("hr", { className: "" + classString })));
};
//# sourceMappingURL=line-component.comp.js.map